import numeral from "numeral";
import moment from "moment";

export default [
    {
        label: 'Part',
        field: 'part_number',
        type: 'text'
    },
    {
        label: 'Stock',
        field: 'stock',
        type: 'text',
        formatFn: (value) => { return numeral(value).format('0,0,0,0,0') },
    },
    {
        label: 'List Price',
        field: 'list_price',
        type: 'number',
        formatFn: (value) => { return numeral(value).format('$0,0,0,0,0.00') },
    },
    {
        label: 'Your Price',
        field: 'your_price',
        type: 'number',
        formatFn: (value) => { return numeral(value).format('$0,0,0,0,0.00') },
    },
    {
        label: 'Discount',
        field: 'discount',
        type: 'text',
        formatFn: (value) => { return value + '%' },
    },
    {
        label: 'Date',
        field: 'orig_created',
        type: 'text',
        formatFn: (value) => { return moment(value).format('YYYY-MM-DD HH:mm') },
    },
]